import React from "react";
import { Box, Text } from "@chakra-ui/react";

import "../styles/logo.css";


export default function Logo(props) {

    return (
        <Box {...props}>
            <Text className={"logo"}>
                M<span>CG</span>
            </Text>
        </Box>
    );
}
